import * as React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '../../constants/Colors';
import { Text, View } from '../Themed';

type Props = {
  text: string;
};

export default function Tag(props: Props) {
  const { text = '' } = props;

  return (
    <View lightColor={Colors.nuetral_grey_400} darkColor={Colors.nuetral_grey_600} style={styles.container}>
      <Text weight="Bold" style={{ color: Colors.nuetral_grey_700 }}>
        {text}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 100,
    paddingHorizontal: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    height: 24,
  },
});
